<script>
	import { onMount } from 'svelte';
	import { goto, ready } from '@roxi/routify';
	import SvelteTable from "svelte-table";
	import { getData, getGETAPILink, postFormData, searchTypeToName } from "../helpers.js";
	import Navbar from "../components/Navbar.svelte";
	import Footer from "../components/Footer.svelte";

	let historyErrorField = '';

	let maxPageCount = 0;
	let maxPageCountPromise = getData('search/historical-page-count')
	maxPageCountPromise.then(response => response.json())
	.then(ret_json => {
		if (ret_json.status === 'success') {
			maxPageCount = ret_json.pages;
		} else {
			recentSearchData = 'An Unknown Error Occured';
		}
	});

	let currentPage = 0;
	let set_page_limit = 10; // default 10
	let recentSearchData = [];
	function loadRecentSearchData(page, page_limit = set_page_limit) {
		let recentSearchDataPromise = getData('search/historical', {'page': page, 'page_limit': page_limit})
		recentSearchDataPromise.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				recentSearchData = ret_json.data;
			} else {
				historyErrorField = 'An Unknown Error Occured';
			}
		});
	}

	loadRecentSearchData(0, 10);

	function nextPage() {
		console.log(currentPage);
		console.log(maxPageCount);
		console.log('nextPage Fired');
        if (currentPage < (maxPageCount-1)) {
            currentPage += 1;
        }
		loadRecentSearchData(currentPage, set_page_limit);
    }

	function prevPage() {
        if (currentPage > 0) {
            currentPage -= 1;
        }
		loadRecentSearchData(currentPage, set_page_limit);
    }

	// Recent History Code
	let sortBy = "creation_time";
	let sortOrder = 1;
	let iconAsc = "↑";
	let iconDesc = "↓";
	let numRows = 5;

	let dateOptions = {}
	const COLUMNS = {
		id: {
			key: "id",
			title: "Agency",
			value: v => v.id.slice(0,10),
			sortable: false,
			headerClass: "bg-gray-200",
		},
		creationTime: {
			key: "creationTime",
			title: "Time",
			value: v => new Date(v.creation_time*1000).toLocaleString('en-US'),
			sortable: true,
			headerClass: "bg-gray-200",
		},
		searchType: {
			key: "searchType",
			title: "Type",
			value: v => searchTypeToName(v.search_type),
			sortable: true,
			headerClass: "bg-gray-200",
		},
		statusName: {
			key: "statusName",
			title: "Status",
			value: v => v.status_name,
			sortable: true,
			headerClass: "bg-gray-200",
		},
		downloadMetadata: {
			key: "downloadMetadata",
			title: "Link",
			value: v => {
				if (v.status_name !== 'ERROR') {
					return 'X'
					//return '<a href="' + getGETAPILink("search/metadata", {"search_id":v.id }) + '" download="' + v.id + '_metadata.txt" target="_self"><button class="w-full border-none">⭳</button></a>';
				} else {
					return 'X'
				}
			},
			sortable: false,
			headerClass: "bg-gray-200",
		},
		downloadFile: {
			key: "downloadFile",
			title: "Zip File",
			value: v => {
				// let type = searchTypeToName(v.search_type);
				if (v.status_name === 'FINISHED' || v.status_name === 'ARCHIVED') {
					return '<a href="' + getGETAPILink("search/download", {"search_id":v.id }) + '" download="' + v.id + '.zip" target="_self"><button class="w-full border-none">⭳</button></a>';
				} else if (v.status_name === 'ERROR') {
					return 'X';
				} else {
					return '-';
				}
			},			sortable: false,
			headerClass: "bg-gray-200",
		},
	};
	//let selectedDesktopCols = ["id", "searchType", "creationTime", "statusName", "downloadMetadata", "downloadFile"];
	let selectedDesktopCols = ["id", "searchType", "creationTime", "statusName", "downloadMetadata"];
	$: desktopCols = selectedDesktopCols.map(key => COLUMNS[key]);

	let selectedMobileCols = ["id", "statusName"];
	$: mobileCols = selectedMobileCols.map(key => COLUMNS[key]);

	let expandedArr = [];
	function handleRowClick(event) {
		// manually toggle expanded items
		const row = event.detail.row;
		if (!row.$expanded) {
			expandedArr = [...expandedArr, row.id];
		} else {
			expandedArr = expandedArr.filter(id => id !== row.id);
		}
	}
</script>

<main class=background>
	<Navbar/>
	<div class="flex flex-col space-y-4 mt-10 items-center lg:justify-center lg:flex-row">
		<div class="mx-2 !mb-4 px-10 py-12 max-w-4xl w-full flex-1 card">
			<p class="text-2xl font-semibold text-blue-900 mb-3">Agency Agenda Settings</p>
			<p class="text-md mb-8 block lg:hidden">(Click to Expand)</p>
			<p class="text-xl text-red-500">{historyErrorField}</p>
			{#if recentSearchData.length !== 0}
			<!-- Shown on large screen -->
			<div class="hidden lg:block">
				<div class="overflow-auto max-h-[50vh]">
					<SvelteTable
					columns={desktopCols}
					rows={recentSearchData}
					classNameRow={'text-lg text-center odd:bg-white even:bg-gray-200'}
					classNameThead={['table-primary sticky top-0 bg-white']}
					classNameTbody={['w-full overflow-scroll']}
					classNameSelect={['rounded-md shadow-sm font-thin py-1 px-2']}
					/>
				</div>
				<div class="flex w-full mt-4">
					<button on:click={prevPage} disabled={currentPage === 0 ? true : false}
					class="float-left w-2/12 text-center pb-2 pt-1 text-xl rounded-md bg-blue-500 disabled:bg-blue-300 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">&lt; Prev</button>
					<p class="mx-auto text-lg pt-1 inline-block">{currentPage+1} of {maxPageCount}</p>
					<button on:click={nextPage} disabled={currentPage === (maxPageCount-1) ? true : false}
					class="float-right w-2/12 text-center pb-2 pt-1 text-xl rounded-md bg-blue-500 disabled:bg-blue-300 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">Next &gt;</button>
				</div>
			</div>
			<!-- Shown on mobile -->
			<div class="block lg:hidden">
				<SvelteTable
					columns={mobileCols}
					rows={recentSearchData}
					classNameRow={'cursor-pointer text-lg text-center'}
					classNameThead={['table-primary sticky top-0 bg-white']}
					classNameTbody={['w-full overflow-scroll']}
					classNameSelect={['rounded-md shadow-sm font-thin py-1 px-2']}
					classNameRowExpanded={'bg-gray-400'}
					classNameExpandedContent={'bg-gray-200'}
					classNameCell={'py-2'}
					expandRowKey="id"
					bind:expanded={expandedArr}
					on:clickRow={handleRowClick}
				>
				<svelte:fragment slot="expanded" let:row>
					<p class="text-center">Search Type: {searchTypeToName(row.search_type)}</p>
					<p class="text-center">Search Time: {new Date(row.creation_time*1000).toLocaleString('en-US')}</p>
					{#if row.status_name !== 'ERROR'}
						<a class="text-blue-500 visited:text-blue-500" href="{getGETAPILink("search/metadata", {"search_id":row.id })}" download="{row.id}_metadata.txt" target="_self">
							<button class="w-full border-none">⭳ Download Agendas ⭳</button>
						</a>
						{#if row.status_name === 'FINISHED'}
							<a class="text-blue-500 visited:text-blue-500" href="{getGETAPILink("search/download", {"search_id":row.id })}" download="{row.id}_metadata.txt" target="_self">
								<button class="w-full border-none">⭳ Download File ⭳</button>
							</a>
						{/if}
					{/if}
				</svelte:fragment>
				</SvelteTable>
				<p class="w-full text-center text-lg pt-1 inline-block">{currentPage+1} of {maxPageCount}</p>
				<div class="flex w-full justify-center space-x-4 mt-4">
					<button on:click={prevPage} disabled={currentPage === 0 ? true : false}
					class="float-left w-5/12 text-center pb-2 pt-1 text-xl rounded-md bg-blue-500 disabled:bg-blue-300 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">&lt; Prev</button>
					<button on:click={nextPage} disabled={currentPage === (maxPageCount-1) ? true : false}
					class="float-right w-5/12 text-center pb-2 pt-1 text-xl rounded-md bg-blue-500 disabled:bg-blue-300 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">Next &gt;</button>
				</div>
			</div>
			{:else}
				<p class="text-xl">No Recent Data Found</p>
			{/if}
		</div>
	</div>
	<Footer/>
</main>

<style>
	main.background { 
		background-color:theme("colors.gray.100");
	}
</style>